import MenuItem from "./MenuItem";

export default MenuItem;
export { MenuItemVariant } from "./MenuItemVariant";
